export const centeredFaqSectionData = {
  readMore: 'Read more FAQs',
} as const;
